import { View, Text, hexColor } from "@lightningtv/solid";
import { createSignal } from "solid-js";
import { changeLanguage, isRTL, t } from "../translations/configuration";
import Header from "./Header";

export default function SetLanguage(props: { onPinSet: () => void }) {
    let enRef, itRef, deRef, esRef, frRef, saRef;

    const [selectedLang, setSelectedLang] = createSignal("en");


    const getStyle = (lang: string) => ({
        width: 180,
        height: 100,
        margin: 10,
        padding: 10,
        borderRadius: 12,
        fontSize: 40,
        color: "#FFFFFF",
        textColor: "#FFFFFF",
        focus: {
            color: "#2563eb",
            textColor: "#FFFFFF",
        },
        alignItems: "center",
        justifyContent: "center",
        border: { width: 2, color: selectedLang() === lang ? 0xffffffaa : 0x00000000 },
    });

    return (
        <View color={"#182027"}>
            <Header screen={""} />

            <Text x={780} y={200} style={{ fontSize: 50, color: hexColor("#8b949e"), fontWeight: isRTL() ? "normal" : "bold" }}>
                {t("chooseLang")}
            </Text>

            <View x={630} y={300} width={620} height={600} borderRadius={24} color={hexColor("#15171b")}>

                <View x={50} y={80} direction="row">
                    <View x={15} y={0} src="https://i.ibb.co/7x245bF6/usa.png" width={50} height={50} borderRadius={30} />
                    <Text
                        x={120}
                        autofocus={true}
                        ref={el => (enRef = el)}
                        style={getStyle("en")}
                        onEnter={() => {
                            changeLanguage("en")
                            props.onPinSet();
                        }}
                        onDown={() => {
                            itRef?.setFocus()
                            console.log('right');
                        }}
                    >
                        English
                    </Text>

                    <View x={15} y={80} src="https://i.ibb.co/VYD4hq0t/Flag-of-Italy-1946-2003.png" width={50} height={50} borderRadius={30} />
                    <Text
                        x={120}
                        ref={el => (itRef = el)}
                        style={getStyle("it")}
                        onEnter={() => {
                            changeLanguage("it")
                            props.onPinSet();
                        }}
                        onUp={() => enRef?.setFocus()}
                        onDown={() => deRef?.setFocus()}
                        y={80}
                    >
                        Italian
                    </Text>

                    <View x={15} y={160} src="https://i.ibb.co/27mzrq4t/Flag-of-Germany-svg.webp" width={50} height={50} borderRadius={30} />
                    <Text
                        x={120}
                        ref={el => (deRef = el)}
                        style={getStyle("de")}
                        onEnter={() => {
                            changeLanguage("de")
                            props.onPinSet();
                        }}
                        onUp={() => itRef?.setFocus()}
                        onDown={() => esRef?.setFocus()}
                        y={160}

                    >
                        German
                    </Text>

                    <View x={15} y={240} src="https://i.ibb.co/0Nds6Fx/Spain-flag-300.png" width={50} height={50} borderRadius={30} />
                    <Text
                        x={120}
                        ref={el => (esRef = el)}
                        style={getStyle("es")}
                        onEnter={() => {
                            changeLanguage("es")
                            props.onPinSet();
                        }}
                        onUp={() => deRef?.setFocus()}
                        onDown={() => frRef?.setFocus()}
                        y={240}

                    >
                        Spanish
                    </Text>

                    <View x={15} y={320} src="https://i.ibb.co/Fb5JmryQ/Flag-of-France.png" width={50} height={50} borderRadius={30} />
                    <Text
                        x={120}
                        ref={el => (frRef = el)}
                        style={getStyle("fr")}
                        onEnter={() => {
                            changeLanguage("fr")
                            props.onPinSet();
                        }}
                        onUp={() => esRef?.setFocus()}
                        onDown={() => saRef?.setFocus()}
                        y={320}

                    >
                        French
                    </Text>

                    <View x={15} y={400} src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Flag_of_Saudi_Arabia.svg/1200px-Flag_of_Saudi_Arabia.svg.png" width={50} height={50} borderRadius={30} />
                    <Text
                        x={120}
                        ref={el => (saRef = el)}
                        style={getStyle("sa")}
                        onEnter={() => {
                            changeLanguage("sa")
                            props.onPinSet();
                        }}
                        onUp={() => frRef?.setFocus()}
                        y={400}
                    >
                        Saudi Arabia
                    </Text>
                </View>
            </View>
        </View>
    );
}
